export default {
  textsArray: [
    'A Video and Written Curriculum for both visual and auditory learners',
    'A Virtual Interview Practice Tool that mimics a real-life interview',
    'Artificial Intelligence that immediately evaluates answers and provides feedback for improvement',
    'Quizzes and Worksheets to reinforce learning',
    'A Resume Builder, templates, and lessons on writing and formatting a first resume',
    'Lessons on professional communication skills, workplace etiquette, social media presence, wardrobe, body language and much, much more',
  ],
  videoUrl:
    'https://uploads-ssl.webflow.com/637be75fec8ead33c23e5491/6387a15f3810ef49de72ad35_train-students.webp',
};
